import type { RowData } from '../../components/KaratCalculator';

// Internal accumulator type ensuring required fields are present during grouping
type AccRow = Required<Pick<RowData, 'metalType' | 'karat' | 'grams' | 'pmp'>> & RowData;

export function groupInventoryForProcessing(
    items: Array<{
        metal_type?: string | null;
        fineness?: number | string | null;
        gross_quantity?: number | string | null;
    }>,
): RowData[] {
    const groups: Record<string, AccRow> = {};
    items.forEach(item => {
        // Avoid default object stringification; only accept strings
        const metalStr = typeof item.metal_type === 'string' ? item.metal_type : '';
        const metalType = metalStr.toUpperCase().includes('ARGINT') ? 'Silver' : 'Gold';
        const karat = Number(item.fineness ?? 0);
        const key = `${metalType}-${karat}`;
        if (!groups[key]) {
            groups[key] = { metalType, karat, grams: 0, pmp: 0 };
        }
        // groups[key] is always defined here and grams is initialized to 0
        groups[key].grams += Number(item.gross_quantity ?? 0);
    });
    return Object.values(groups).map(r => ({ ...r, grams: +r.grams.toFixed(2) }));
}
